<template>
  <div v-code="authId" style="display: inline-block">
    <template v-if="btn">
      <button
        class="btn btn-sm btn-labeled btn-rounded"
        :class="btnClass"
        v-if="!slotBtn"
      >
        <i class="btn-label" :class="iconClass" v-if="iconClass"></i> {{ text }}
      </button>
      <slot></slot>
    </template>
    <template v-else>
      <router-link
        :to="href"
        class="btn btn-sm btn-labeled btn-rounded"
        :class="btnClass"
      >
        <i class="btn-label" :class="iconClass" v-if="iconClass"></i> {{ text }}
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    btn: {
      type: Boolean,
      default: false,
    },
    slotBtn: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    iconClass: {
      type: String,
      default: null,
    },
    authId: {
      type: Number,
      default: 0,
    },
    btnClass: {
      type: String,
      default: 'btn-default',
    },
  },
}
</script>